import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormGroup, FormControl, AbstractControl, Validators, FormArray } from '@angular/forms';
import { IFormBase } from '../../model/form-base.interface';
import { FormChildDirective } from '../../directive/form-child.directive';
import { ButtonComponent } from '../../../../core/component/core/button/button.component';
import { FormFooterComponent } from '../form-footer/form-footer.component';
import { FormViewDirective } from '../../directive/form-view.directive';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-form-base',
  template: '<p> app form base </p>'
})
export class FormBaseComponent<T> {

  form: FormGroup;
  formArray: FormArray;
  isChild: boolean = false;
  isShow: boolean = true;
  state: T;
  subscription;

  @Input()
  parent: FormGroup;

  @Input()
  parentArray: FormArray;

  @Input()
  childName: string;

  

  @Input()
  merge: boolean = false;

  @Output()
  onComplete: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild(FormViewDirective)
  view: FormViewDirective;

  @ViewChild(FormFooterComponent)
  footer: FormFooterComponent;


  init(subscribe: boolean = false) {
    this.form = new FormGroup({
      id: new FormControl()
    });

    this.formArray = new FormArray([]);

    

    if (this.parent) {
      this.isChild = true;
      if (!this.merge) {
        if (this.view) {
          this.view.addChildClass()
          this.view.hide();
        }
        if (this.footer) {
          this.footer.isChild = this.isChild;
        }
      } else {
        if (this.footer) {
          this.footer.hideAll();
        }
      }
      if (this.childName) {
        
        if(this.parentArray)
        {
          this.parentArray.push(this.form);
          this.parent.addControl(this.childName, this.parentArray);
          
          //this.parentArray.push(this.form);
          //this.parent.addControl(this.childName, new FormArray([ ]) )

        }
        else
        {
          this.parent.addControl(this.childName, this.form);  
        }
        

      } else {
        this.form = this.parent;
      }
    }
    this.template();
    if (subscribe) {
      this.subscribe();
    }
  }

  subscribe() {
    this.subscription = this.form.valueChanges
      .subscribe(state => {
        this.state = state;
        this.update(this.state)
      })
  }


  get(name: string): AbstractControl {
    return this.form.get(name);
  }

  data() {
    return this.form.valid ? this.form.value : null;
  }

  send() {
    this.onComplete.emit(this.form.value);
  }

  clear() {
    this.form.reset();
  }

  onFormClose(reset: boolean) {
    this.view.hide();
    this.onComplete.emit(this.form.value);
    if (reset) {
      this.form.reset();
    }
  }

  toggle() {
    this.view.toggle();
  }

  toggleValue(value) {
    this.view.toggleValue(!value.target.checked);
  }

  destroy() {
    this.subscription.unsubscribe();
  }

  template() { }
  update(state: any) { }

}



// WEBPACK FOOTER //
// ./src/app/form/core/component/form-base/form-base.component.ts